import { BannerProductDeleteDto } from './dto/banner-product-delete-dto';
import { CreateOrEditBannerDto } from './dto/create-or-edit-banner-dto';
import {
  BannersListObjDto,
  BannersListDto,
  AvailableBannersDto,
} from './dto/banners-list-dto';
import ApiService from '../../utils/base-api/api-service';
import { BannerProductListDto } from './dto/banner-product-list-dto';
import { BannerProductInsertDto } from './dto/banner-product-insert-dto';
import { PorductVariantSkuDto } from './dto/porduct-variant-sku-dto';
import { IPaginateProducts } from 'src/shared/common-dtos/get-all-paginate';
import { IProductOption } from '../product/dtos/product-option';
import {
  PagedSelectParams,
  PagedSelectResponse,
} from 'src/shared/hooks/usePagedSelectOptions';

class BannersService extends ApiService {
  constructor() {
    super({
      baseURL: '/AdminBanner',
    });
  }

  getBannersList(
    queryPaginate?: IPaginateProducts,
  ): Promise<BannersListObjDto> {
    return this.post('/List', undefined, {
      params: queryPaginate,
    });
  }

  initializeBannerValues(): Promise<BannersListDto> {
    return this.post('/InitializeData');
  }

  getSubCategories(
    maiCategoryId: string,
    mainCategoryName?: string,
  ): Promise<Array<AvailableBannersDto>> {
    return this.get('/GetSubCategories', {
      params: {
        categoryId: maiCategoryId,
        categoryName: mainCategoryName,
      },
    });
  }

  create(input: CreateOrEditBannerDto) {
    return this.post('/Create', input);
  }

  getBannerById(bannerId: string): Promise<BannersListDto> {
    return this.get('/getBannerByID', {
      params: {
        id: bannerId,
      },
    });
  }

  edit(input: CreateOrEditBannerDto) {
    return this.put('/Edit', input);
  }

  deleteBanner(bannerId: string) {
    return this.delete('/Delete', {
      params: {
        id: bannerId,
      },
    });
  }

  getBannerProductList(bannerId: string): Promise<Array<BannerProductListDto>> {
    return this.post('/BannerProductList', null, {
      params: {
        id: bannerId,
      },
    });
  }

  getProductOptionsByCategoryId(
    categoryId: string,
  ): Promise<Array<AvailableBannersDto>> {
    return this.get('/GetProductOptionsByCategoryId', {
      params: {
        categoryId: categoryId,
      },
    });
  }

  // One page of the category's approved products (a shop admin's own only),
  // searched by name.
  getPagedProductOptionsByCategoryId(
    categoryId: string,
    params: PagedSelectParams,
  ): Promise<PagedSelectResponse<IProductOption>> {
    return this.get('/GetPagedProductOptionsByCategoryId', {
      params: {
        categoryId: categoryId,
        keyword: params.Keyword,
        page: params.Page,
        pageSize: params.PageSize,
      },
    });
  }

  getPorductVariantSkuByProductId(
    productId: string,
  ): Promise<Array<PorductVariantSkuDto>> {
    return this.get('/GetPorductVariantSkuByProductId', {
      params: {
        productId: productId,
      },
    });
  }

  bannerProductInsert(input: BannerProductInsertDto) {
    return this.post('/BannerProductInsert', input);
  }

  bannerProductDelete(input: BannerProductDeleteDto) {
    return this.post('/BannerProductDelete', null, {
      params: input,
    });
  }
}

export const bannersService = new BannersService();
